import {
  StateProps,
  ContainerProps,
  makeMapStateToProps,
  mapDispatchToProps,
  DispatchProps,
} from "./map-to-props-factory";
import { ComponentProps } from "./props";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";

export default withSportsbookBetslipContext(({ localization, capabilities }: SportsbookBetslipContext) => ({
  localization,
  capabilities,
}))(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
